import mapboxgl from 'mapbox-gl';

export const MAP_STYLE_URLS = {
    regular: 'mapbox://styles/mapbox/dark-v10',
    satellite: 'mapbox://styles/mapbox/satellite-streets-v11',
} as const;

/** Swaps the map between the regular and satellite base styles. */
export const applyMapStyle = (map: mapboxgl.Map, isSatellite: boolean): void => {
    // diff: true patches the style in place when it can, skipping 'style.load' and stranding runtime-added sources and layers.
    // The typings wrongly require the font-family fields; passing them, even as undefined, would overwrite the map's font defaults.
    map.setStyle(isSatellite ? MAP_STYLE_URLS.satellite : MAP_STYLE_URLS.regular, { diff: false } as Parameters<mapboxgl.Map['setStyle']>[1]);
};
